import { NormalizeOAS, OASRequestParams, OASResponse } from 'fets';
import type assetLibraryOpenApi from '../asset-library-open-api';
import { AssetLibraryFetsApiClient } from '../asset-library-fets-client';
import { assertNever } from '../utils';
import { Guid } from '../../api/public/utils/Guid';
import { Folder } from './createAssetFolder';

const PATH = '/api/v2/asset-directory-tree/company/{companyId}';

type Params = {
  companyId: Guid;
};

type Result = { folders: Folder[] };

export type ApiFunction = (params: Params, signal?: AbortSignal) => Promise<Result>;

export const createGetAssetDirectoryTree = (apiClient: AssetLibraryFetsApiClient): ApiFunction => {
  const getAssetDirectoryTree = async (params: Params, signal?: AbortSignal): Promise<Result> => {
    const response = await apiClient[PATH].get({
      ...convertToRequest(params),
      ...(signal && { signal }),
    });

    return convertResponse(response);
  };

  return getAssetDirectoryTree;
};

type Request = OASRequestParams<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'get'>;
type Response = OASResponse<NormalizeOAS<typeof assetLibraryOpenApi>, typeof PATH, 'get'>;

const convertToRequest = (params: Params): Request => ({
  params: { companyId: params.companyId },
});

const convertResponse = async (response: Response): Promise<Result> => {
  const responseStatus = response.status;
  if (responseStatus !== 200) {
    return assertNever(responseStatus);
  }

  const data = await response.json();
  return {
    folders: data.folders.map((folder) => ({
      id: folder.id,
      name: folder.name,
      parentId: folder.parentId ?? null,
    })),
  };
};
